const DEFAULT_MAX_STAT_PROBES = 3;

const buildAtomicBoardStatCandidates = (
  stats = {},
  preferredStat = "",
  maxProbes = DEFAULT_MAX_STAT_PROBES,
  excludedStats = []
) => {
  const excluded = new Set((Array.isArray(excludedStats) ? excludedStats : []).map(String));
  const available = Object.keys(stats || {}).filter((statKey) => !excluded.has(String(statKey)));
  const preferred = String(preferredStat || "");
  const ordered = preferred && available.includes(preferred)
    ? [preferred, ...available.filter((statKey) => statKey !== preferred)]
    : available;
  const boundedMax = Number.isFinite(Number(maxProbes)) && Number(maxProbes) > 0
    ? Math.floor(Number(maxProbes))
    : DEFAULT_MAX_STAT_PROBES;

  return ordered.slice(0, boundedMax);
};

const createAtomicBoardTransition = ({ requestToken, sport = "", stat = "", sourceSport = "" } = {}) => ({
  requestToken,
  sport: String(sport || "").toLowerCase(),
  stat: String(stat || ""),
  sourceSport: String(sourceSport || "").toLowerCase(),
});

const atomicBoardTransitionMatches = (transition, requestToken) => (
  Boolean(transition) && transition.requestToken === requestToken
);

module.exports = {
  DEFAULT_MAX_STAT_PROBES,
  atomicBoardTransitionMatches,
  buildAtomicBoardStatCandidates,
  createAtomicBoardTransition,
};
